// work data

export const Work = [
  {
    id: 1,
    name: "🌟 GSoC 2025 – Apache Lucene.NET",
    description:
      "Developed a new Lucene.NET Replicator extension to enhance Lucene.NET’s scalability and integration. Now serving as an official Apache Committer.",
    tags: ["gsoc2025", "lucene", "asp.net Core", "open-source"],
    demo: "https://gist.github.com/NehanPathan/4e51b02556cc0c23117e9b0776bef60a",
    github: "https://github.com/paulirwin/lucenenet-extensions",
  },
  {
    id: 2,
    name: "💻 My Backend Journey",
    description:
      "A collection of hands-on projects and practice examples where I’ve explored everything from basics to modern libraries used in real-world .NET Core apps.",
    tags: ["asp.net core", "backend", "api", "learning"],
    demo: "https://github.com/NehanPathan/ASP.NET-CORE-Learning/blob/master/README.md",
    github: "https://github.com/NehanPathan/ASP.NET-Core-Learning",
  },
  {
    id: 3,
    name: "🍳 Recipe & List Manager",
    description:
      "A simple app to save recipes and plan shopping, built with love using Angular and Firebase.",
    tags: ["angular", "firebase", "auth"],
    demo: "https://reciepe-book-76e22.web.app/",
    github:
      "https://github.com/NehanPathan/RecipeBook_ShoppingList_Angular-Project",
  },
  {
    id: 4,
    name: "🎉 Mini Projects Collection",
    description:
      "A playful set of small experiments from my early days — drum kits, hacker view, and more fun stuff.",
    tags: ["html", "css", "js", "fun"],
    demo: "https://nehanpathan.github.io/2023-Replit-Trail-Projects/",
    github: "https://nehanpathan.github.io/2023-Replit-Trail-Projects/",
  },

  //   {
  //     id: 5,
  //     name: "",
  //     description:"Coming Soon....",
  //     tags:[],

  //     demo: "",
  //     github: "",
  //   },

  //   {
  //     id: 6,
  //     name: "",
  //     description:"Coming Soon....",
  //     tags:[],

  //     demo: "",
  //     github: "",
  //   },
];
